export const CHECKBOX_TH_WIDTH = 50;
